import { useReportFilters } from "../../../../contexts/ReportFiltersContext";
import { formatRangeLabel } from "../../../../utils/dateRange";

const PipelineFilters = () => {
  const {
    compareEnabled,
    setCompareEnabled,
    compareFrom,
    compareTo,
    from,
    to,
  } = useReportFilters();

  const canCompare = !!(from && to);

  return (
    <div className="flex flex-wrap items-center gap-3 px-3 py-2 rounded-lg bg-white border border-gray-200">
      <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer select-none">
        <input
          type="checkbox"
          checked={compareEnabled}
          disabled={!canCompare}
          onChange={(e) => setCompareEnabled(e.target.checked)}
          className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
        />
        So sánh với kỳ trước
      </label>
      {compareEnabled && compareFrom && compareTo && (
        <span className="text-xs text-gray-500 inline-flex items-center gap-1.5">
          <span className="inline-block w-2 h-2 rounded-full bg-gray-300" />
          Kỳ trước: {formatRangeLabel(compareFrom, compareTo)}
        </span>
      )}
    </div>
  );
};

export default PipelineFilters;
